import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {StorageService} from '../../../services/storage.service';
import {AuthService} from '../../../services/auth.service';
import {MatDialog} from '@angular/material/dialog';
import {DomainPickerDialogComponent} from '../domain-picker-dialog/domain-picker-dialog.component';

@Component({
  selector: 'app-domain-viewer',
  templateUrl: './domain-viewer.component.html',
  styleUrls: ['./domain-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DomainViewerComponent implements OnInit, OnDestroy {
  public domain: string;
  public loading = true;

  constructor(
    private userService: UserService,
    protected storageService: StorageService,
    private authService: AuthService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.authService.authChecked.subscribe((checked) => {
      if (checked) {
        this.loading = false;
      }
    });
    this.userService.userSubject.subscribe((user) => {
      if (user) {
        const stored = this.storageService.getDomain();
        this.domain = stored || user.domain;
        this.storageService.setDomain(this.domain);
      } else {
        this.storageService.flushDomain();
        this.domain = null;
      }
    });
  }

  ngOnDestroy(): void {
    this.userService.userSubject.unsubscribe();
  }

  openDomainPicker(): void {
    this.dialog.open(DomainPickerDialogComponent, {
      data: {
        domains: this.userService.user?.domainAccessList || [],
        currentDomain: this.domain,
        defaultDomain: this.userService.user?.domain
      }
    });
  }
}
